import { render, staticRenderFns } from "./FeatureTour.vue?vue&type=template&id=6a1cedb0&"
import script from "./FeatureTour.vue?vue&type=script&lang=js&"
export * from "./FeatureTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports